import { breakpoints } from 'config/config';
import styled from 'styled-components';

export const StyledListings = styled.div`
  @media only screen and (max-width: ${breakpoints.lg}px) {
    .mobile-list-card-cover-title {
      display: flex;
      flex-direction: column;
      width: 100%;

      .label {
        color: ${({ theme }) => theme.cardFirstElement};
      }

      span {
        font-size: 0.875rem;
      }
    }
    .mobile-list-card-body-wrapper .mobile-list-card-body-item {
      padding-bottom: 10px;
      margin-bottom: 10px;
      border-bottom: 1px solid ${({ theme }) => theme.inputAddonBg};

      span {
        font-size: 0.875rem;
      }
    }

    .mobile-list-card-body-wrapper
      .mobile-list-card-body-item:nth-last-child(-n + 2) {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
    }

    .mobile-list-card-body-wrapper .ant-tag.status {
      display: inline-block;
      width: fit-content;
      margin-top: 2px;
    }

    .actions-title {
      text-align: start;
    }

    .mobile-list-card-body-item .ant-btn-link {
      padding: 0;
      justify-content: flex-start;
      height: auto;
    }
  }

  .actions-title {
    text-align: center;
  }

  .status,
  .ant-tag.status {
    padding: 3px 10px;
    line-height: 18px;
    border-radius: 36px;
    font-size: 12px;
    color: ${({ theme }) => theme.white} !important;
    border: none;
    margin: 0;
  }

  .ant-tag.unpublished,
  .unpublished {
    background-color: ${({ theme }) => theme.statusUnpublished};
  }

  .ant-tag.published,
  .published {
    background-color: ${({ theme }) => theme.statusPublished};
  }

  .ant-tag.has_offers,
  .has_offers {
    background-color: ${({ theme }) => theme.statusHasOffers};
  }

  .ant-tag.closed,
  .closed {
    background-color: ${({ theme }) => theme.statusClosed};
  }

  .ant-tag.partially_completed,
  .partially_completed {
    background-color: ${({ theme }) => theme.statusPartiallyCompleted};
  }

  .ant-tag.completed,
  .completed {
    background-color: ${({ theme }) => theme.statusCompleted};
  }

  .ant-tag.cancelled,
  .cancelled {
    background-color: ${({ theme }) => theme.statusCancelled};
  }

  .ant-tag.unsuccessful,
  .unsuccessful {
    background-color: ${({ theme }) => theme.statusUnsuccessful};
  }

  .ant-select-selector {
    min-width: 150px;
  }

  .action {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .results-links {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .results-label {
    padding: 19px 20px;
  }

  .link-with-icon {
    display: inline-flex;
    align-items: center;
    gap: 6px;

    .link-icon {
      display: flex;
      justify-content: center;
    }

    &:hover {
      opacity: 0.8;
    }
  }

  .mobile-actions-button {
    width: 100%;
    border-color: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.primary};

    &:hover {
      border-color: ${({ theme }) => theme.primary};
      color: ${({ theme }) => theme.primary};
      opacity: 0.9;
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .link {
      padding: 0;
      justify-content: start;
    }

    .mobile-list-card-body-item {
      padding-bottom: 10px;
      border-bottom: 1px solid ${({ theme }) => theme.inputAddonBg};
    }
  }
`;

export const StatusCell = styled.div`
  text-align: center;

  @media only screen and (max-width: ${breakpoints.lg}px) {
    text-align: end;

    .ant-tag {
      margin: 0;
      color: ${({ theme }) => theme.white} !important;
      font-size: 0.75rem;
    }
  }
`;
